import React from 'react';
import { Users } from 'lucide-react';
import { Checkbox } from '../../../catalyst/checkbox';
import { Badge } from '../../../catalyst/badge';
import { displayName } from '../crew/viewHelpers';

const CrewSelectionPanel = ({ 
  activeCrew, 
  selectedCrew, 
  onToggleCrewSelection, 
  onSelectAllCrew 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full">
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900 flex items-center">
            <Users className="h-5 w-5 mr-2 text-gray-500" />
            Select Crew Members
          </h3>
          <button
            onClick={onSelectAllCrew}
            className="text-sm text-cyan-600 hover:text-cyan-700"
          >
            {selectedCrew.length === activeCrew.length ? 'Deselect All' : 'Select All'}
          </button>
        </div>
      </div>
      <div className="p-4 max-h-96 overflow-y-auto">
        <div className="space-y-2">
          {activeCrew.map(member => (
            <label key={member.id} className="flex items-center gap-3 p-3 border rounded-lg hover:bg-gray-50 cursor-pointer">
              <Checkbox
                checked={selectedCrew.includes(member.id)}
                onChange={() => onToggleCrewSelection(member.id)}
              />
              <div className="flex-1">
                <p className="font-medium text-gray-900">{displayName(member)}</p>
                <p className="text-sm text-gray-500">{member.position || member.role || 'Crew'}</p>
              </div>
            </label>
          ))}
        </div>
        {selectedCrew.length > 0 && (
          <div className="mt-4 p-3 bg-cyan-50 rounded-lg">
            <p className="text-sm text-cyan-900">
              {selectedCrew.length} crew member{selectedCrew.length !== 1 ? 's' : ''} selected
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CrewSelectionPanel;